import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#060609] border-t border-tactical-800/50 py-12" data-id="element-17">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        {/* Brand */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-19">
          <ShieldIcon className="w-5 h-5 text-cyan-accent" data-id="element-20" />
          <span className="font-heading text-lg font-bold text-white uppercase tracking-widest" data-id="element-21">
            Sentinel Bundle
          </span>
        </div>

        {/* Legal links */}
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 mb-8 text-sm" data-id="element-22">
          <a href="#" className="text-gray-500 hover:text-gray-300 transition-colors" data-id="element-23">
            Términos y Condiciones
          </a>
          <span className="text-tactical-800 hidden sm:inline" data-id="element-24">|</span>
          <a href="#" className="text-gray-500 hover:text-gray-300 transition-colors" data-id="element-25">
            Política de Privacidad
          </a>
          <span className="text-tactical-800 hidden sm:inline" data-id="element-26">|</span>
          <a href="#" className="text-gray-500 hover:text-gray-300 transition-colors" data-id="element-27">
            Política de Reembolso
          </a>
        </div>

        {/* Disclaimer */}
        <p className="text-xs text-gray-600 text-center max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-28">
          Este producto es de carácter educativo e informativo. Los resultados
          pueden variar según la situación individual de cada persona. No
          garantizamos resultados específicos. Toda la información proporcionada
          es para fines de preparación personal y no constituye asesoramiento
          financiero, legal o profesional.
        </p>

        {/* Copyright */}
        <p className="text-xs text-gray-600 text-center" data-id="element-29">
          © {currentYear} Sentinel Bundle. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}